import { makeStyles } from '@material-ui/core/styles';
import { ISpcTheme } from '../../../../../common/theme/ISpcTheme';

export type SummaryTypographyOrClasses = 'secondaryPrice' | 'priceText' | 'marginNormal';

const summaryTypographyOrStyles = makeStyles<ISpcTheme, SummaryTypographyOrClasses>(
  theme => ({
    secondaryPrice: {
      fontFamily: theme.typography.fontFamily2,
    },
    priceText: {
      fontSize: theme.typography.fontLG,
      color: theme.palette.primary.main,
      [theme.breakpoints.down('md')]: {
        fontSize: theme.typography.fontMD,
      },
    },
    marginNormal: {
      margin: '0 2px',
    },
  }),
  { name: 'ConfigSummary_SummaryTypographyOr' },
);

export default summaryTypographyOrStyles;
